<div class="user_preview" *ngIf="user" (click)="showFullView($event)" (mouseleave)="hideFullView($event)">
  <img [src]="photoUrl">
  <div class="initials">
    {{initials}}
  </div>
</div>
